export const colors = {
  terminal: {
    bg: '#0a0a0a',
    green: '#00ff41',
    greenMuted: '#00cc33',
    dimGreen: '#00aa2a',
    darkGreen: '#003d00',
    amber: '#ffb000',
    amberDim: '#cc8d00',
    red: '#ff073a',
    redDim: '#cc0530',
    cyan: '#00d4ff',
    cyanDim: '#00a3c4',
    magenta: '#ff00ff',
  },
  surface: {
    primary: '#0d1117',
    elevated: '#161b22',
    overlay: '#1c2333',
    border: '#1a3a1a',
    borderLight: '#2a5a2a',
    borderSubtle: '#141e14',
  },
  text: {
    primary: '#c9d1d9',
    secondary: '#8b949e',
    muted: '#8b949e',
    inverse: '#0a0a0a',
  },
};

export const cssVariables = Object.entries({
  '--terminal-bg': colors.terminal.bg,
  '--terminal-green': colors.terminal.green,
  '--terminal-green-muted': colors.terminal.greenMuted,
  '--terminal-dim-green': colors.terminal.dimGreen,
  '--terminal-dark-green': colors.terminal.darkGreen,
  '--terminal-amber': colors.terminal.amber,
  '--terminal-amber-dim': colors.terminal.amberDim,
  '--terminal-red': colors.terminal.red,
  '--terminal-red-dim': colors.terminal.redDim,
  '--terminal-cyan': colors.terminal.cyan,
  '--terminal-cyan-dim': colors.terminal.cyanDim,
  '--terminal-magenta': colors.terminal.magenta,
  '--surface-primary': colors.surface.primary,
  '--surface-elevated': colors.surface.elevated,
  '--surface-overlay': colors.surface.overlay,
  '--surface-border': colors.surface.border,
  '--surface-border-light': colors.surface.borderLight,
  '--surface-border-subtle': colors.surface.borderSubtle,
  '--text-primary': colors.text.primary,
  '--text-secondary': colors.text.secondary,
  '--text-muted': colors.text.muted,
}).reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
